import { Action, ActionHandler } from '@components/MultipleActionsInterfaces';
import MassActionsBar from '@components/v2/layout/MassActionsBar/MassActionsBar';
import { Box } from '@mui/material';
import { CalendarClock, Trash2 } from 'lucide-react';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../../../../utils/testIds/CatalogProducts.testIds';

type CatalogAccessMassActionType = 'change_dates_batch' | 'remove_batch';

const CATALOG_ACCESS_MASS_ACTIONS: Action<CatalogAccessMassActionType>[] = [
  {
    label: LangEnum.CATALOGS_ENTITY_MASS_ACTIONS_CHANGE_ACCESS_DATES,
    icon: CalendarClock,
    type: 'change_dates_batch',
    isMassAction: true,
  },
  {
    label: LangEnum.GLOBAL_REMOVE,
    icon: Trash2,
    type: 'remove_batch',
    isMassAction: true,
    showShortcut: true,
  },
];

interface CatalogAccessMassActionsBarSelectionConfig {
  totalSelected: number;
  totalResults: number;
  isAllSelected: boolean;
  isSelectingAllResults: boolean;
  onToggleSelectAll: () => void;
  onToggleSelectAllResults: () => void;
  onDeselectAll: () => void;
}

interface CatalogAccessMassActionsBarActionsConfig {
  onChangeDates: () => void;
  onRemoveSelected: () => void;
}

interface CatalogAccessMassActionsBarProps {
  selection: CatalogAccessMassActionsBarSelectionConfig;
  actions: CatalogAccessMassActionsBarActionsConfig;
}

const CatalogAccessMassActionsBar = ({ selection, actions }: CatalogAccessMassActionsBarProps) => {
  const handleClickAction: ActionHandler<CatalogAccessMassActionType> = (action) => {
    if (action.type === 'change_dates_batch') {
      actions.onChangeDates();

      return;
    }

    actions.onRemoveSelected();
  };

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        minHeight: 44,
        paddingLeft: 0.75,
        paddingRight: 1.5,
        backgroundColor: theme.palette.accent.dark,
        borderRadius: `${theme.shape.borderRadiusLg}px`,
      })}
    >
      <MassActionsBar<CatalogAccessMassActionType>
        totalSelected={selection.totalSelected}
        isAllSelected={selection.isAllSelected}
        actions={CATALOG_ACCESS_MASS_ACTIONS}
        testId={CatalogProductsTestIds.DETAILS_ACCESS_MASS_ACTIONS_BAR}
        toggleAllSelected={selection.onToggleSelectAll}
        deselectAll={selection.onDeselectAll}
        massActionFilter={{
          enabled: true,
          value: selection.isSelectingAllResults,
          totalResults: selection.totalResults,
          onToggle: selection.onToggleSelectAllResults,
        }}
        onClickAction={handleClickAction}
      />
    </Box>
  );
};

export default CatalogAccessMassActionsBar;
